<template lang="pug">
  .auth-control(v-if="!authUser")
    a.auth-control__register.default-bold(
      :href="makeHref('register')" target="_blank" data-test="register-button"
    ) Register
    lei-btn.auth-control__login(
      type="cyprus rounded-3xl" size="sm" fill @click="toggleAuthModal('noChallenge')" data-test="login-button"
    ) Login
  .auth-control__info-panel(v-else)
    user-info-section

</template>
<script>
import { mapGetters, mapMutations, } from 'vuex'
import { challengeURL, } from '@/constants/api'
import LeiBtn from '../lei-components/LeiBtn'
import { TOGGLE_AUTH_MODAL, } from '@/store/modules/auth/mutations-types'
import UserInfoSection from '@/components/record-details/UserInfoSection'


export default {
  components: {
    LeiBtn,
    UserInfoSection,
  },
  computed: {
    ...mapGetters('auth', [ 'authUser', ]),

  },
  methods: {
    makeHref: (route) => `${challengeURL}${route}`,
    ...mapMutations('auth', {
      toggleAuthModal: TOGGLE_AUTH_MODAL,
    }),
  },
}
</script>
<style lang="stylus">
  @import "../../assets/styles/variables.styl"
  .auth-control
    padding 15px 20px
    display flex
    @media (max-width: $mobile-l)
      padding 0
      .auth-control__register
        padding 10px 0
    @media (max-width: $mobile)
      flex-direction column
      .auth-control__register
        padding 10px 20px
        margin 0
    &__register
      padding 10px 20px
      margin-right 10px
      &:hover
        color $turquoise-color
    &__info-panel
      background-color $white-color
      min-width 180px
      padding 10px 20px
      border 1px solid $default-color
      @media (max-width: $laptop)
        padding 5px 10px
        min-width auto
      .container
        min-width auto
        padding 0
        width 100%
        margin-bottom 0
        .logged-as
          width 100%
        .logged-user-info
          flex-wrap wrap

</style>



// WEBPACK FOOTER //
// src/components/auth-components/authControl.vue